import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import {
  Box,
  Grid,
  Modal,
  TableCell,
  TableRow,
  Typography,
  tableCellClasses,
} from "@mui/material";
import React, { useState } from "react";
import { useMutation } from "react-query";
import styled from "styled-components";
import { v4 as uuid } from "uuid";
import { GetPermissionSubGroupsResponse } from "../../../models/permission.model";
import { DeletePermission } from "../../../services/permission.service";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "#F9FAFC",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  // direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

interface Props {
  permissions: GetPermissionSubGroupsResponse;
  setUpdateReports: (updateReports: string) => void;
  setSubPermission: (state: GetPermissionSubGroupsResponse) => void;
  setOpenAddSubPermissionModal: (state: boolean) => void;
  setAddOrEdit: (state: "Add" | "Edit") => void;
}

const PermissionAccardionTableRows = ({
  permissions,
  setUpdateReports,
  setSubPermission,
  setOpenAddSubPermissionModal,
  setAddOrEdit,
}: Props) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const { mutate: DeletePermissionMutate } = useMutation(DeletePermission, {
    onSuccess: (data: boolean) => {
      if (data) {
        setUpdateReports(uuid());
      }
    },
    onError: () => {},
  });

  return (
    <>
      <StyledTableRow>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {permissions.title}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {permissions.permissionType}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {permissions.permissionGroupTitle}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {permissions.applicationTitle}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {permissions.createDatePersian}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {permissions.creatorUserFullName}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" sx={{ borderTop: "none !important" }}>
          <div
            style={{
              marginBottom: "-.5vh",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ModeEditOutlinedIcon
              onClick={() => {
                setSubPermission(permissions);
                setOpenAddSubPermissionModal(true);
                setAddOrEdit("Edit");
              }}
              style={{
                color: "#1D4A87",
                cursor: "pointer",
                marginInline: "3px",
              }}
            />
            <DeleteOutlineIcon
              onClick={() => setOpenDeleteModal(true)}
              style={{
                color: "#1D4A87",
                cursor: "pointer",
                marginInline: "3px",
              }}
            />
          </div>
        </StyledTableCell>
      </StyledTableRow>
      {/* delete modal */}
      <div>
        <Modal
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={deactiveUserStyle}>
            <Typography
              component={"p"}
              display={"block"}
              textAlign={"center"}
              fontWeight={"bold"}
              marginY={"3rem"}
              fontSize={"14px"}
            >
              آیا از حذف کردن{" "}
              <span style={{ color: "#E6123D" }}>"{permissions.title}"</span>{" "}
              اطمینان دارید؟
            </Typography>
            <Grid container justifyContent={"center"} gap={"1rem"}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                sx={{
                  backgroundColor: "#E6123D",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                padding={"0.5rem"}
                maxWidth={"150px !important"}
              >
                <Typography
                  textAlign={"center"}
                  color={"#FFF"}
                  fontWeight={"bold"}
                  // onClick={handleDel}
                  onClick={() => {
                    DeletePermissionMutate({
                      permissionId: permissions.id,
                    });
                  }}
                >
                  بله
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                sx={{
                  backgroundColor: "#607D8B",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                padding={"0.5rem"}
                maxWidth={"150px !important"}
              >
                <Typography
                  textAlign={"center"}
                  color={"#FFF"}
                  fontWeight={"bold"}
                  onClick={() => setOpenDeleteModal(false)}
                >
                  خیر
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default PermissionAccardionTableRows;
